/*
  import { notifyError } from '@/services/notify'

	import { listBoardPackages } from '@/services/BoardMeetings/BoardPackage/List';

  const { list, successful, message } = await listBoardPackages ({
    params: {
			hoaID
    }
  });
  if (!successful) {
    notifyError (message);
    return;
  }
*/

import _get from 'lodash/get'
import kms from '@/services/kms'

export async function listBoardPackages({ params }) {
  let message = 'The board meetings list could not be retrieved.'

  try {
    const result = await kms.get(`/BoardMeetings/BoardPackage/List`, {
      params: {
        hoaID: params.hoaID,
        numberOfMonthsBack: params.numberOfMonthsBack ? params.numberOfMonthsBack : null
      }
    })

    let list = _get(result, 'results', [])
    if (!Array.isArray(list)) {
      list = []
    }

    return {
      successful: true,
      message,
      list
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    successful: false,
    message,
    list: []
  }
}
